export var SAVE_AND_SUBMIT_ACTION = "saveAndSubmit";
export var REST_API_ACTION = "restAPI";
export var LOOKUP_ACTION = "lookup";
export var UPDATE_FORM = "UPDATE_FORM";
export var UPDATE_COMPONENT = "UPDATE_COMPONENT";
export var UPDATE_SUBMISSION = "UPDATE_SUBMISSION";
export var RESET_SUBMISSION = "RESET_SUBMISSION";
export var INITIAL_FORM = {
    id: "",
    name: "",
    version: 0,
};
//# sourceMappingURL=common.js.map